import { render } from "./MariKonsul.vue?vue&type=template&id=6b6606a4"
import script from "./MariKonsul.vue?vue&type=script&lang=js"
export * from "./MariKonsul.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__